module.exports = " <div> <div class=Modal__header> <h3>Choisir une couleur</h3> </div> <div class=Modal__body> <color-picker :colors.sync=hexColor></color-picker> </div> <div class=Modal__footer> <button class=Modal__buton-ok @click=cancel()> Ok </button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/modals/ColorPicker.vue
// module id = 505
// module chunks = 1